import React from 'react';
import loadable from '@loadable/component';

import getPageDataLoadingAPI from '../containers/pageDataLoadingAPI';
import NotFoundPage from '../containers/NotFoundPage/NotFoundPage';
import PreviewResolverPage from '../containers/PreviewResolverPage/PreviewResolverPage';

// routeConfiguration needs to initialize containers first
// Otherwise, components will import form container eventually and
// at that point css bundling / imports will happen in wrong order.
import { NamedRedirect } from '../components';
const pageDataLoadingAPI = getPageDataLoadingAPI();
const FavouritePage = loadable(() => import(/* webpackChunkName: "AuthenticationPage" */ '../containers/RuleBooksSearchPage/FavouritePage/FavouritePage'));
const AuthenticationPage = loadable(() => import(/* webpackChunkName: "AuthenticationPage" */ '../containers/AuthenticationPage/AuthenticationPage'));
const CartPage = loadable(() => import(/* webpackChunkName: "CartPage" */ '../containers/CartPage/CartPage'));
const CheckoutPage = loadable(() => import(/* webpackChunkName: "CheckoutPage" */ '../containers/CheckoutPage/CheckoutPage'));
const CMSPage = loadable(() => import(/* webpackChunkName: "CMSPage" */ '../containers/CMSPage/CMSPage'));
const ContactDetailsPage = loadable(() => import(/* webpackChunkName: "ContactDetailsPage" */ '../containers/ContactDetailsPage/ContactDetailsPage'));
const DeleteAccountPage = loadable(() => import(/* webpackChunkName: "DeleteAccountPage" */ '../containers/DeleteAccountPage/DeleteAccountPage'));
const EditListingPage = loadable(() => import(/* webpackChunkName: "EditListingPage" */ '../containers/EditListingPage/EditListingPage'));
const EmailVerificationPage = loadable(() => import(/* webpackChunkName: "EmailVerificationPage" */ '../containers/EmailVerificationPage/EmailVerificationPage'));
const InboxPage = loadable(() => import(/* webpackChunkName: "InboxPage" */ '../containers/InboxPage/InboxPage'));
const LandingPage = loadable(() => import(/* webpackChunkName: "LandingPage" */ '../containers/LandingPage/LandingPage'));
const ListingPageCoverPhoto = loadable(() => import(/* webpackChunkName: "ListingPageCoverPhoto" */ /* webpackPrefetch: true */ '../containers/ListingPage/ListingPageCoverPhoto'));
const ListingPageCarousel = loadable(() => import(/* webpackChunkName: "ListingPageCarousel" */ /* webpackPrefetch: true */ '../containers/ListingPage/ListingPageCarousel'));
const ManageListingsPage = loadable(() => import(/* webpackChunkName: "ManageListingsPage" */ '../containers/ManageListingsPage/ManageListingsPage'));
const PasswordChangePage = loadable(() => import(/* webpackChunkName: "PasswordChangePage" */ '../containers/PasswordChangePage/PasswordChangePage'));
const PasswordRecoveryPage = loadable(() => import(/* webpackChunkName: "PasswordRecoveryPage" */ '../containers/PasswordRecoveryPage/PasswordRecoveryPage'));
const PasswordResetPage = loadable(() => import(/* webpackChunkName: "PasswordResetPage" */ '../containers/PasswordResetPage/PasswordResetPage'));
const PaymentMethodsPage = loadable(() => import(/* webpackChunkName: "PaymentMethodsPage" */ '../containers/PaymentMethodsPage/PaymentMethodsPage'));
const PrivacyPolicyPage = loadable(() => import(/* webpackChunkName: "PrivacyPolicyPage" */ '../containers/PrivacyPolicyPage/PrivacyPolicyPage'));
const ProfilePage = loadable(() => import(/* webpackChunkName: "ProfilePage" */ '../containers/ProfilePage/ProfilePage'));
const ProfileSettingsPage = loadable(() => import(/* webpackChunkName: "ProfileSettingsPage" */ '../containers/ProfileSettingsPage/ProfileSettingsPage'));
const SearchPageWithMap = loadable(() => import(/* webpackChunkName: "SearchPageWithMap" */ /* webpackPrefetch: true */  '../containers/SearchPage/SearchPageWithMap'));
const SearchPageWithGrid = loadable(() => import(/* webpackChunkName: "SearchPageWithGrid" */ /* webpackPrefetch: true */  '../containers/SearchPage/SearchPageWithGrid'));
const StripePayoutPage = loadable(() => import(/* webpackChunkName: "StripePayoutPage" */ '../containers/StripePayoutPage/StripePayoutPage'));
const TermsOfServicePage = loadable(() => import(/* webpackChunkName: "TermsOfServicePage" */ '../containers/TermsOfServicePage/TermsOfServicePage'));
const TransactionPage = loadable(() => import(/* webpackChunkName: "TransactionPage" */ '../containers/TransactionPage/TransactionPage'));
const NoAccessPage = loadable(() => import(/* webpackChunkName: "NoAccessPage" */ '../containers/NoAccessPage/NoAccessPage'));

const SignUpStepsPage = loadable(() => import(/* webpackChunkName: "NoAccessPage" */ '../containers/SignUpStepsPage/SignUpStepsPage'));
// Styleguide helps you to review current components and develop new ones
const StyleguidePage = loadable(() => import(/* webpackChunkName: "StyleguidePage" */ '../containers/StyleguidePage/StyleguidePage'));

const CircleCommunityPage = loadable(() => import(/* webpackChunkName: "CircleCommunityPage" */ '../containers/CircleCommunityPage/CircleCommunityPage'));
const JoinedGroupsCommunityPage = loadable(() => import(/* webpackChunkName: "JoinedGroupsCommunityPage" */ '../containers/JoinedGroupsCommunityPage/JoinedGroupsCommunityPage'));
const DiscoverGroupsCommunityPage = loadable(() => import(/* webpackChunkName: "DiscoverGroupsCommunityPage" */ '../containers/DiscoverGroupsCommunityPage/DiscoverGroupsCommunityPage'));
const MyGroupCommunityPage = loadable(() => import(/* webpackChunkName: "MyGroupCommunityPage" */ '../containers/MyGroupCommunityPage/MyGroupCommunityPage'));
const MyGroupCommunityPageForUnknownUser = loadable(() => import(/* webpackChunkName: "MyGroupCommunityPageForUnknownUser" */ '../containers/MyGroupCommunityPageForUnknownUser/MyGroupCommunityPageForUnknownUser'));
const GroupSearchPage = loadable(() => import(/* webpackChunkName: "GroupSearchPage" */ '../containers/GroupSearchPage/GroupSearchPage'));

const StripeSubscriptionPage = loadable(() => import(/* webpackChunkName: "CircleCommunityPage" */ '../containers/StripeSubscriptionPage/StripeSubscriptionPage'));
const DiscountsLandingPage = loadable(() => import(/* webpackChunkName: "DiscountsLandingPage" */ '../containers/DiscountsLandingPage/DiscountsLandingPage'));

const PostViewPage = loadable(() => import(/* webpackChunkName: "PostViewPage" */ '../containers/PostViewPage/PostViewPage'));

const AlgoliaSearchPage = loadable(() => import(/* webpackChunkName: "AlgoliaSearchPage" */ '../containers/AlgoliaSearchPage/AlgoliaSearchPage'));

const ShippingInfoPage = loadable(() => import(/* webpackChunkName: "ShippingInfoPage" */ '../containers/ShippingInfoPage/ShippingInfoPage'));
const YouthAccountSettingsPage = loadable(() => import(/* webpackChunkName: "YouthAccountSettingsPage" */ '../containers/YouthAccountSettingsPage/YouthAccountSettingsPage'));

const AdminPanelSupabasePage = loadable(() => import(/* webpackChunkName: "AdminPanelSupabasePage" */ '../containers/AdminPanelSupabasePage/AdminPanelSupabasePage'));
const AdminPanelChatHistoryPage = loadable(() => import(/* webpackChunkName: "AdminPanelChatHistoryPage" */ '../containers/AdminPanelChatHistoryPage/AdminPanelChatHistoryPage'));
const AdminPanelOrganisationPage = loadable(() => import(/* webpackChunkName: "AdminPanelSupabasePage" */ '../containers/AdminPanelOrganisationPage/AdminPanelOrganisationPage'));
const AdminPanelWalletPage = loadable(() => import(/* webpackChunkName: "AdminPanelSupabasePage" */ '../containers/AdminPanelWalletPage/AdminPanelWalletPage'));
const AdminPanelShopifyFeeReportPage = loadable(() => import(/* webpackChunkName: "AdminPanelShopifyFeeReportPage" */ '../containers/AdminPanelShopifyFeeReportPage/AdminPanelShopifyFeeReportPage'));
const AdminPanelCategoryPage = loadable(() => import(/* webpackChunkName: "AdminPanelCategoryPage" */ '../containers/AdminPanelCategoryPage/AdminPanelCategoryPage'));
const AdminPanelDiscountCodesPage = loadable(() => import(/* webpackChunkName: "AdminPanelDiscountCodesPage" */ '../containers/AdminPanelDiscountCodesPage/AdminPanelDiscountCodesPage'));
const AdminPanelDailyDealsPage = loadable(() => import(/* webpackChunkName: "AdminPanelDailyDealsPage" */ '../containers/AdminPanelDailyDealsPage/AdminPanelDailyDealsPage'));
const AdminPanelHighlightsPage = loadable(() => import(/* webpackChunkName: "AdminPanelHighlightsPage" */ '../containers/AdminPanelHighlightsPage/AdminPanelHighlightsPage'));
const AdminPanelDiscoverGroupsCarouselsPage = loadable(() => import(/* webpackChunkName: "AdminPanelDiscoverGroupsCarouselsPage" */ '../containers/AdminPanelDiscoverGroupsCarouselsPage/AdminPanelDiscoverGroupsCarouselsPage'));
const AdminPanelSubscriptionsPage = loadable(() => import(/* webpackChunkName: "AdminPanelSubscriptionsPage" */ '../containers/AdminPanelSubscriptionsPage/AdminPanelSubscriptionsPage'));
const AiChatBotPage = loadable(() => import(/* webpackChunkName: "AiChatBotPage" */ '../containers/AiChatBotPage/AiChatBotPage'));
const RuleBooksSearchPage = loadable(() => import(/* webpackChunkName: "RuleBooksSearchPage" */ '../containers/RuleBooksSearchPage/RuleBooksSearchPage'));
const AdminPanelModeratorsPage = loadable(() => import(/* webpackChunkName: "AdminPanelModeratorsPage" */ '../containers/AdminPanelModeratorsPage/AdminPanelModeratorsPage'));
const SubscriptionCheckoutPage = loadable(() => import(/* webpackChunkName: "SubscriptionCheckoutPage" */ '../containers/SubscriptionCheckoutPage/SubscriptionCheckoutPage'));

const GroupPaymentSuccessPage = loadable(() => import(/* webpackChunkName: "GroupPaymentSuccessPage" */ '../containers/GroupPaymentSuccessPage/GroupPaymentSuccessPage'));
const GroupPaymentHistoryPage = loadable(() => import(/* webpackChunkName: "GroupPaymentHistoryPage" */ '../containers/GroupPaymentHistoryPage/GroupPaymentHistoryPage'));
const AdminPanelUserPage = loadable(() => import(/* webpackChunkName: "AdminPanelUserPage" */ '../containers/AdminPanelUserPage/AdminPanelUserPage'));

const GeneralHourPage = loadable(() => import(/* webpackChunkName: "GeneralHourPage" */ '../containers/GeneralHourPage/GeneralHourPage'));
const AlgoliaDirectorySearchPage = loadable(() => import(/* webpackChunkName: "AlgoliaDirectorySearchPage" */ '../containers/AlgoliaSearchPage/AlgoliaDirectorySearchPage'));
const ShopifyOnboardingPage = loadable(() => import(/* webpackChunkName: "ShopifyOnboardingPage" */ '../containers/ShopifyOnboardingPage/ShopifyOnboardingPage'));


export const ACCOUNT_SETTINGS_PAGES = [
  'ContactDetailsPage',
  'PasswordChangePage',
  'StripePayoutPage',
  'PaymentMethodsPage',
  "ShippingInfoPage",
  "YouthAccountSettingsPage",
  "GroupPaymentHistoryPage"
];

export const isAdminNavSelected = [
  "AdminPanelSupabasePage",
  "AdminPanelOrganisationPage",
  "AdminPanelWalletPage",
  "AdminPanelShopifyFeeReportPage",
  "AdminPanelModeratorsPage",
  "AdminPanelDiscountCodesPage",
  "AdminPanelDailyDealsPage",
  "AdminPanelHighlightsPage",
  "AdminPanelDiscoverGroupsCarouselsPage",
  "AdminPanelSubscriptionsPage",
  "AdminPanelHighlightCategoryPage"
]

// https://en.wikipedia.org/wiki/Universally_unique_identifier#Nil_UUID
const draftId = '00000000-0000-0000-0000-000000000000';
const draftSlug = 'draft';

const RedirectToLandingPage = () => <NamedRedirect name="LandingPage" />;

// NOTE: Most server-side endpoints are prefixed with /api. Requests to those
// endpoints are indended to be handled in the server instead of the browser and
// they will not render the application. So remember to avoid routes starting
// with /api and if you encounter clashing routes see server/index.js if there's
// a conflicting route defined there.

// Our routes are exact by default.
// See behaviour from Routes.js where Route is created.
const routeConfiguration = (layoutConfig, accessControlConfig) => {
  const SearchPage = layoutConfig.searchPage?.variantType === 'map'
    ? SearchPageWithMap
    : SearchPageWithGrid;
  const ListingPage = layoutConfig.listingPage?.variantType === 'carousel'
    ? ListingPageCarousel
    : ListingPageCoverPhoto;

  const isPrivateMarketplace = accessControlConfig?.marketplace?.private === true;
  const authForPrivateMarketplace = isPrivateMarketplace ? { auth: true } : {};

  return [
    {
      path: '/',
      name: 'HomeLandingPage',
      component: LandingPage,
      loadData: pageDataLoadingAPI.LandingPage.loadData,
    },
    {
      path: '/home',
      name: 'LandingPage',
      component: LandingPage,
      loadData: pageDataLoadingAPI.LandingPage.loadData,
    },
    {
      path: '/p/:pageId',
      name: 'CMSPage',
      component: CMSPage,
      loadData: pageDataLoadingAPI.CMSPage.loadData,
    },
    {
      path: '/s',
      name: 'SearchPage',
      ...authForPrivateMarketplace,
      component: AlgoliaSearchPage,
      // loadData: pageDataLoadingAPI.SearchPage.loadData,
    },
    {
      path: '/directory-user',
      name: 'AlgoliaDirectorySearchPage',
      auth: true,
      component: AlgoliaDirectorySearchPage,
    },
    {
      path: '/feed-page',
      name: 'CircleCommunityPage',
      auth: true,
      component: CircleCommunityPage,
      loadData: pageDataLoadingAPI.CircleCommunityPage.loadData,
    },
    {
      path: '/feed-page/explore',
      name: 'ExploreCommunityPage',
      auth: true,
      component: CircleCommunityPage,
      loadData: pageDataLoadingAPI.CircleCommunityPage.loadData,
    },
    {
      path: '/feed-page/my-group/c/:slug/:id',
      name: 'MyGroupCommunityPage',
      auth: true,
      component: MyGroupCommunityPage,
      loadData: pageDataLoadingAPI.MyGroupCommunityPage.loadData,
    },
    {
      path: '/feed-page/my-group-public/c/:slug/:id',
      name: 'MyGroupCommunityPageForUnknownUser',
      component: MyGroupCommunityPageForUnknownUser,
      loadData: pageDataLoadingAPI.MyGroupCommunityPageForUnknownUser.loadData,
    },
    {
      path: '/feed-page/discover-groups/c/:slug/:id',
      name: 'DiscoverGroupsCommunityPage',
      auth: true,
      // component: DiscoverGroupsCommunityPage,
      // loadData: pageDataLoadingAPI.DiscoverGroupsCommunityPage.loadData,
       component: props => (
        <NamedRedirect
          name="MyGroupCommunityPage"
          params={{ id: props.params?.id, slug: props.params?.slug }}
          search={props.location?.search || ''}
        />
      ),
    },
    {
      path: '/feed-page/joined-groups/c/:slug/:id',
      name: 'JoinedGroupsCommunityPage',
      auth: true,
      // component: JoinedGroupsCommunityPage,
      // loadData: pageDataLoadingAPI.JoinedCommunityGroupsPage.loadData,
       component: props => (
        <NamedRedirect
          name="MyGroupCommunityPage"
          params={{ id: props.params?.id, slug: props.params?.slug }}
          search={props.location?.search || ''}
        />
      ),
    },
    {
      path: '/post-page/c/:slug/:postId/:spaceId',
      name: 'PostViewPage',
      auth: true,
      component: PostViewPage,
      loadData: pageDataLoadingAPI.PostViewPage.loadData,
    },
    {
      path: '/feed-page/group-search',
      name: 'GroupSearchPage',
      // auth: true,
      component: GroupSearchPage,
      loadData: pageDataLoadingAPI.GroupSearchPage.loadData,
    },
    {
      path: '/l',
      name: 'ListingBasePage',
      component: RedirectToLandingPage,
    },
    {
      path: '/l/:category/:subCategory/:slug/:id', // /category/sub-category/listing-title
      name: 'ListingPage',
      ...authForPrivateMarketplace,
      component: ListingPage,
      loadData: pageDataLoadingAPI.ListingPage.loadData,
    },
    {
      path: '/l/:slug/:id/checkout',
      name: 'CheckoutPage',
      auth: true,
      component: CheckoutPage,
      setInitialValues: pageDataLoadingAPI.CheckoutPage.setInitialValues,
    },
    {
      path: '/l/:category/:subCategory/:slug/:id/:variant',
      name: 'ListingPageVariant',
      auth: true,
      authPage: 'LoginPage',
      component: ListingPage,
      loadData: pageDataLoadingAPI.ListingPage.loadData,
    },
    {
      path: '/l/new',
      name: 'NewListingPage',
      auth: true,
      component: () => (
        <NamedRedirect
          name="EditListingPage"
          params={{ slug: draftSlug, id: draftId, type: 'new', tab: 'details' }}
        />
      ),
    },
    {
      path: '/edit-listing/:slug/:id/:type/:tab',
      name: 'EditListingPage',
      auth: true,
      component: EditListingPage,
      loadData: pageDataLoadingAPI.EditListingPage.loadData,
    },
    {
      path: '/edit-listing/:slug/:id/:type/:tab/:returnURLType',
      name: 'EditListingStripeOnboardingPage',
      auth: true,
      component: EditListingPage,
      loadData: pageDataLoadingAPI.EditListingPage.loadData,
    },

    // Canonical path should be after the `/l/new` path since they
    // conflict and `new` is not a valid listing UUID.
    {
      path: '/l/:id',
      name: 'ListingPageCanonical',
      ...authForPrivateMarketplace,
      component: ListingPage,
      loadData: pageDataLoadingAPI.ListingPage.loadData,
    },
    {
      path: '/u',
      name: 'ProfileBasePage',
      component: RedirectToLandingPage,
    },
    {
      path: '/u/:id',
      name: 'ProfilePage',
      ...authForPrivateMarketplace,
      component: ProfilePage,
      loadData: pageDataLoadingAPI.ProfilePage.loadData,
    },
    {
      path: '/u/:id/:variant',
      name: 'ProfilePageVariant',
      auth: true,
      component: ProfilePage,
      loadData: pageDataLoadingAPI.ProfilePage.loadData,
    },
    {
      path: '/profile-settings',
      name: 'ProfileSettingsPage',
      auth: true,
      authPage: 'LoginPage',
      component: ProfileSettingsPage,
    },
    {
      path: '/profile-general-hours',
      name: 'GeneralHourPage',
      auth: true,
      authPage: 'LoginPage',
      component: GeneralHourPage,
    },
    // Note: authenticating with IdP (e.g. Facebook) expects that /login path exists
    // so that in the error case users can be redirected back to the LoginPage
    // In case you change this, remember to update the route in server/api/auth/loginWithIdp.js
    {
      path: '/login',
      name: 'LoginPage',
      component: AuthenticationPage,
      extraProps: { tab: 'login' },
    },
    {
      path: '/signup',
      name: 'SignupPage',
      component: AuthenticationPage,
      extraProps: { tab: 'signup' },
      loadData: pageDataLoadingAPI.AuthenticationPage.loadData,
    },
    {
      path: '/signup/youth-invite/:invite_id',
      name: 'SignupYouthPage',
      component: AuthenticationPage,
      extraProps: { tab: 'signup' },
      loadData: pageDataLoadingAPI.AuthenticationPage.loadData,
    },
    {
      path: '/signup/:userType',
      name: 'SignupForUserTypePage',
      component: AuthenticationPage,
      extraProps: { tab: 'signup' },
      loadData: pageDataLoadingAPI.AuthenticationPage.loadData,
    },
    {
      path: '/welcome/:tab',
      name: 'SignUpStepsPage',
      auth: true,
      component: SignUpStepsPage,
      loadData: pageDataLoadingAPI.SignUpStepsPage.loadData,
    },
    {
      path: '/confirm',
      name: 'ConfirmPage',
      component: AuthenticationPage,
      extraProps: { tab: 'confirm' },
      loadData: pageDataLoadingAPI.AuthenticationPage.loadData,
    },
    {
      path: '/recover-password',
      name: 'PasswordRecoveryPage',
      component: PasswordRecoveryPage,
    },
    {
      path: '/inbox',
      name: 'InboxBasePage',
      auth: true,
      authPage: 'LoginPage',
      component: () => <NamedRedirect name="InboxPage" params={{ tab: 'sales' }} />,
    },
    {
      path: '/inbox/:tab',
      name: 'InboxPage',
      auth: true,
      authPage: 'LoginPage',
      component: InboxPage,
      loadData: pageDataLoadingAPI.InboxPage.loadData,
    },
    {
      path: '/order/:id',
      name: 'OrderDetailsPage',
      auth: true,
      authPage: 'LoginPage',
      component: TransactionPage,
      extraProps: { transactionRole: 'customer' },
      loadData: (params, ...rest) =>
        pageDataLoadingAPI.TransactionPage.loadData({ ...params, transactionRole: 'customer' }, ...rest),
      setInitialValues: pageDataLoadingAPI.TransactionPage.setInitialValues,
    },
    {
      path: '/order/:id/details',
      name: 'OrderDetailsPageRedirect',
      auth: true,
      authPage: 'LoginPage',
      component: props => <NamedRedirect name="OrderDetailsPage" params={{ id: props.params?.id }} />,
    },
    {
      path: '/sale/:id',
      name: 'SaleDetailsPage',
      auth: true,
      authPage: 'LoginPage',
      component: TransactionPage,
      extraProps: { transactionRole: 'provider' },
      loadData: pageDataLoadingAPI.TransactionPage.loadData,
    },
    {
      path: '/sale/:id/details',
      name: 'SaleDetailsPageRedirect',
      auth: true,
      authPage: 'LoginPage',
      component: props => <NamedRedirect name="SaleDetailsPage" params={{ id: props.params?.id }} />,
    },
    {
      path: '/listings',
      name: 'ManageListingsPage',
      auth: true,
      authPage: 'LoginPage',
      component: ManageListingsPage,
      loadData: pageDataLoadingAPI.ManageListingsPage.loadData,
    },
    // {
    //   path: '/shopify/onboarding/:tab',
    //   name: 'ShopifyOnboardingPageTab',
    //   auth: true,
    //   authPage: 'LoginPage',
    //   component: ShopifyOnboardingPage,
    //   loadData: pageDataLoadingAPI.ShopifyOnboardingPage.loadData,
    // },
    {
      path: '/account',
      name: 'AccountSettingsPage',
      auth: true,
      authPage: 'LoginPage',
      component: () => <NamedRedirect name="ContactDetailsPage" />,
    },
    {
      path: '/account/contact-details',
      name: 'ContactDetailsPage',
      auth: true,
      authPage: 'LoginPage',
      component: ContactDetailsPage,
      loadData: pageDataLoadingAPI.ContactDetailsPage.loadData,
    },
     {
      path: '/account/delete-account',
      name: 'DeleteAccountPage',
      auth: true,
      authPage: 'LoginPage',
      component: DeleteAccountPage,
    },
    {
      path: '/account/change-password',
      name: 'PasswordChangePage',
      auth: true,
      authPage: 'LoginPage',
      component: PasswordChangePage,
    },
    {
      path: '/account/shipping-info',
      name: 'ShippingInfoPage',
      auth: true,
      authPage: 'LoginPage',
      component: ShippingInfoPage,
      loadData: pageDataLoadingAPI.ShippingInfoPage.loadData,
    },
    {
      path: '/account/youth-account',
      name: 'YouthAccountSettingsPage',
      auth: true,
      authPage: 'LoginPage',
      component: YouthAccountSettingsPage,
      loadData: pageDataLoadingAPI.YouthAccountSettingsPage.loadData,
    },
    {
      path: '/account/payments',
      name: 'StripePayoutPage',
      auth: true,
      authPage: 'LoginPage',
      component: StripePayoutPage,
      loadData: pageDataLoadingAPI.StripePayoutPage.loadData,
    },
    {
      path: '/account/payments/:returnURLType',
      name: 'StripePayoutOnboardingPage',
      auth: true,
      authPage: 'LoginPage',
      component: StripePayoutPage,
      loadData: pageDataLoadingAPI.StripePayoutPage.loadData,
    },
    {
      path: '/account/payment-methods',
      name: 'PaymentMethodsPage',
      auth: true,
      authPage: 'LoginPage',
      component: PaymentMethodsPage,
      loadData: pageDataLoadingAPI.PaymentMethodsPage.loadData,
    },
    {
      path: '/terms-of-service',
      name: 'TermsOfServicePage',
      component: TermsOfServicePage,
      loadData: pageDataLoadingAPI.TermsOfServicePage.loadData,
    },
    {
      path: '/privacy-policy',
      name: 'PrivacyPolicyPage',
      component: PrivacyPolicyPage,
      loadData: pageDataLoadingAPI.PrivacyPolicyPage.loadData,
    },
    {
      path: '/styleguide',
      name: 'Styleguide',
      ...authForPrivateMarketplace,
      component: StyleguidePage,
    },
    {
      path: '/styleguide/g/:group',
      name: 'StyleguideGroup',
      ...authForPrivateMarketplace,
      component: StyleguidePage,
    },
    {
      path: '/styleguide/c/:component',
      name: 'StyleguideComponent',
      ...authForPrivateMarketplace,
      component: StyleguidePage,
    },
    {
      path: '/styleguide/c/:component/:example',
      name: 'StyleguideComponentExample',
      ...authForPrivateMarketplace,
      component: StyleguidePage,
    },
    {
      path: '/styleguide/c/:component/:example/raw',
      name: 'StyleguideComponentExampleRaw',
      ...authForPrivateMarketplace,
      component: StyleguidePage,
      extraProps: { raw: true },
    },
    {
      path: '/no-:missingAccessRight',
      name: 'NoAccessPage',
      component: NoAccessPage,
    },
    {
      path: '/notfound',
      name: 'NotFoundPage',
      component: props => <NotFoundPage {...props} />,
    },

    // Do not change this path!
    //
    // The API expects that the application implements /reset-password endpoint
    {
      path: '/reset-password',
      name: 'PasswordResetPage',
      component: PasswordResetPage,
    },
    {
      path: '/subscribe',
      name: 'StripeSubscriptionPage',
      auth: true,
      component: StripeSubscriptionPage,
      loadData: pageDataLoadingAPI.StripeSubscriptionPage.loadData,
    },
    {
      path: '/discounts',
      name: 'DiscountsLandingPage',
      component: DiscountsLandingPage,
      // No loadData: the server-side data call carries no user session, so it would be
      // rejected by the admin-only gate. The page fetches its deals on the client instead.
    },
    // Do not change this path!
    //
    // The API expects that the application implements /verify-email endpoint
    {
      path: '/verify-email',
      name: 'EmailVerificationPage',
      auth: true,
      authPage: 'LoginPage',
      component: EmailVerificationPage,
      loadData: pageDataLoadingAPI.EmailVerificationPage.loadData,
    },
    // Do not change this path!
    //
    // The API expects that the application implements /preview endpoint
    {
      path: '/preview',
      name: 'PreviewResolverPage',
      component: PreviewResolverPage,
    },
    {
      path: '/cart',
      name: 'CartPage',
      auth: true,
      authPage: 'LoginPage',
      component: CartPage,
      loadData: pageDataLoadingAPI.CartPage.loadData,
    },
    {
      path: '/admin/supabase/:tab',
      name: 'AdminPanelSupabasePage',
      auth: true,  // Require authentication
      authPage: 'LoginPage',
      component: AdminPanelSupabasePage,
      loadData: pageDataLoadingAPI.AdminPanelSupabasePage.loadData,
    },
    {
      path: '/admin/supabase/:tab/:rulebookId/:rulebookSlug',
      name: 'AdminPanelChatHistoryPage',
      auth: true,  // Require authentication
      authPage: 'LoginPage',
      component: AdminPanelChatHistoryPage,
      loadData: pageDataLoadingAPI.AdminPanelChatHistoryPage.loadData,
    },
    {
      path: '/admin/organisation',
      name: 'AdminPanelOrganisationPage',
      auth: true,  // Require authentication
      authPage: 'LoginPage',
      component: AdminPanelOrganisationPage,
      loadData: pageDataLoadingAPI.AdminPanelOrganisationPage.loadData,
    },
    {
      path: '/admin/wallet',
      name: 'AdminPanelWalletPage',
      auth: true,  // Require authentication
      authPage: 'LoginPage',
      component: AdminPanelWalletPage,
      loadData: pageDataLoadingAPI.AdminPanelWalletPage.loadData,
    },
    // {
    //   path: '/admin/shopify-fee-report',
    //   name: 'AdminPanelShopifyFeeReportPage',
    //   auth: true,  // Require authentication
    //   authPage: 'LoginPage',
    //   component: AdminPanelShopifyFeeReportPage,
    //   loadData: pageDataLoadingAPI.AdminPanelShopifyFeeReportPage.loadData,
    // },
    {
      path: '/admin/categories',
      name: 'AdminPanelCategoryPage',
      auth: true,  // Require authentication
      authPage: 'LoginPage',
      component: AdminPanelCategoryPage,
      loadData: pageDataLoadingAPI.AdminPanelCategoryPage.loadData,
    },
    {
      path: '/admin/discount-codes',
      name: 'AdminPanelDiscountCodesPage',
      auth: true,
      authPage: 'LoginPage',
      component: AdminPanelDiscountCodesPage,
      loadData: pageDataLoadingAPI.AdminPanelDiscountCodesPage.loadData,
    },
    {
      path: '/admin/daily-deals',
      name: 'AdminPanelDailyDealsPage',
      auth: true,
      authPage: 'LoginPage',
      component: AdminPanelDailyDealsPage,
      loadData: pageDataLoadingAPI.AdminPanelDailyDealsPage.loadData,
    },
    {
      path: '/admin/discover-groups-carousels',
      name: 'AdminPanelDiscoverGroupsCarouselsPage',
      auth: true,
      authPage: 'LoginPage',
      component: AdminPanelDiscoverGroupsCarouselsPage,
      loadData: pageDataLoadingAPI.AdminPanelDiscoverGroupsCarouselsPage.loadData,
    },
    {
      path: '/admin/subscriptions',
      name: 'AdminPanelSubscriptionsPage',
      auth: true,
      authPage: 'LoginPage',
      component: AdminPanelSubscriptionsPage,
      loadData: pageDataLoadingAPI.AdminPanelSubscriptionsPage.loadData,
    },
    {
      path: '/admin/highlights/:categoryId',
      name: 'AdminPanelHighlightCategoryPage',
      auth: true,
      authPage: 'LoginPage',
      component: AdminPanelHighlightsPage,
      loadData: pageDataLoadingAPI.AdminPanelHighlightsPage.loadData,
    },
    {
      path: '/admin/highlights',
      name: 'AdminPanelHighlightsPage',
      auth: true,
      authPage: 'LoginPage',
      component: AdminPanelHighlightsPage,
      loadData: pageDataLoadingAPI.AdminPanelHighlightsPage.loadData,
    },
    {
      path: '/admin/moderators',
      name: 'AdminPanelModeratorsPage',
      auth: true,  // Require authentication
      authPage: 'LoginPage',
      component: AdminPanelModeratorsPage,
      loadData: pageDataLoadingAPI.AdminPanelModeratorsPage.loadData,
    },
     {
      path: '/admin/users',
      name: 'AdminPanelUserPage',
      auth: true,  // Require authentication
      authPage: 'LoginPage',
      component: AdminPanelUserPage,
      loadData: pageDataLoadingAPI.AdminPanelUserPage.loadData,
    },
    {
      path: '/chatbot-ai',
      name: 'AiChatBotPage',
      auth: true,
      authPage: 'LoginPage',
      component: AiChatBotPage,
      loadData: pageDataLoadingAPI.AiChatBotPage.loadData,
    },
    {
      path: '/chatbot-ai/:rulebookId/:sessionId',
      name: 'AiChatBotRulebookPage',
      auth: true,
      authPage: 'LoginPage',
      component: AiChatBotPage,
      loadData: pageDataLoadingAPI.AiChatBotPage.loadData,
    },
    {
      path: '/search-rulebook/:rulebookId',
      name: 'RuleBooksSearchPage',
      // auth: true,
      // authPage: 'LoginPage',
      component: RuleBooksSearchPage,
      loadData: pageDataLoadingAPI.RuleBooksSearchPage.loadData,
    },
    {
      path: '/my-favourites-rulebook/:rulebookId',
      name: 'FavouritePage',
      auth: true,
      authPage: 'LoginPage',
      component: FavouritePage,
      loadData: pageDataLoadingAPI.RuleBooksSearchPage.loadData,
    },
    {
      path: '/purchase/:paymentId/:customerGroupPaymentId/:groupId',
      name: 'SubscriptionCheckoutPage',
      auth: true,
      authPage: 'LoginPage',
      component: SubscriptionCheckoutPage,
      loadData: pageDataLoadingAPI.SubscriptionCheckoutPage.loadData,
    },
    {
      path: '/group-purchase-success/:customerGroupPaymentId',
      name: 'GroupPaymentSuccessPage',
      auth: true,
      authPage: 'LoginPage',
      component: GroupPaymentSuccessPage,
    },
    {
      path: '/group-payment-history/:tab',
      name: 'GroupPaymentHistoryPage',
      auth: true,
      authPage: 'LoginPage',
      component: GroupPaymentHistoryPage,
      loadData: pageDataLoadingAPI.GroupPaymentHistoryPage.loadData,
    }
  ];
};

export default routeConfiguration;
